module.exports = __webpack_public_path__ + "img/people_lhj.6a685719.png";